import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { ToastService } from "app/modules/shared/services/message/toast.service";
import { UnitsDto } from "app/modules/dashboard/modules/material-management/unit/model/units.dto";
import { BaseForm } from "app/data/shared/models/base-form.interface";
import { ApiService } from "app/modules/shared/services/base/api.service";
import { ExplorerService } from "app/modules/shared/services/explorer.service";
import { KlLoadingService } from "app/modules/shared/services/kl-loading.service";
import { KlDyModalComponent } from "app/modules/dashboard/components/partials/modal/modal.component";
import { UtilService } from "app/modules/shared/services/util.service";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";

@Component({
  selector: "kl-new-unit",
  templateUrl: "./unit-form.component.html",
  styleUrls: ["./unit-form.component.scss"],
})
export class UnitFormComponent
  implements OnInit, AfterViewInit, OnDestroy, BaseForm
{
  @ViewChild("UnitsForm", { static: true }) private unitsForm;
  @ViewChild("focusElement", { static: true }) private elementFocus: ElementRef;
  @Input() entity: UnitsDto = new UnitsDto();
  @Input() isReadOnly: boolean;
  @Input() mode: string;
  @Input() tabId: string;
  @Input() listTabId: string;
  @Input() modalId: string;
  alertShow: boolean;
  alertType: string;
  alertMessage: string;
  saveForm = false;
  isOpen = true;
  title = "";

  constructor(
    private apiService: ApiService,
    public klModal: KlDyModalComponent,
    private klLoadingService: KlLoadingService,
    private toastService: ToastService,
    private translateService: TranslateService,
    private explorerService: ExplorerService,
    private utilService: UtilService
  ) {}

  ngOnInit() {
    switch (this.mode) {
      case "add":
        this.title =
          this.translateService.instant("new") +
          " " +
          this.translateService.instant("unit");
        break;
      case "view":
      case "edit":
        this.title = this.translateService.instant("unit") + " - ";
        this.klLoadingService.hide();
        break;
    }
  }

  ngAfterViewInit() {
    this.elementFocus.nativeElement.focus();
  }

  clearForm() {
    this.elementFocus.nativeElement.focus();
    Object.keys(this.entity).forEach((o) => delete this.entity[o]);
  }

  commitSave(action: any) {
    if (this.unitsForm.valid) {
      this.saveForm = true;
      switch (action) {
        case "SAVE":
          switch (this.mode) {
            case "add":
              this.apiService.addData("unit", this.entity).subscribe(
                (response) => this.handleResponse(response),
                (error) => this.handleError(error)
              );
              break;
            case "edit":
              this.apiService.updateData("unit", this.entity).subscribe(
                (response) => this.handleResponse(response),
                (error) => this.handleError(error)
              );
              break;
          }
          break;
        case "SAVE_NEW":
          this.apiService.addData("unit", this.entity).subscribe(
            (response) => this.handleNew(response),
            (error) => this.handleError(error)
          );
          break;
      }
    } else {
      this.alertShow = true;
      this.alertType = "error";
      this.alertMessage = "required_fields_must_be_entered";
    }
  }

  handleResponse(response) {
    this.klLoadingService.hide();
    this.toastService.toastSuccess();
    if (this.modalId) {
      this.explorerService.closeModal(this);
    }
    if (this.listTabId) {
      this.explorerService.setRefreshEndProsseses(this.listTabId);
    }
  }

  handleNew(response) {
    this.saveForm = false;
    this.alertShow = false;
    this.toastService.toastSuccess();
    this.clearForm();
  }

  handleError(error) {
    this.saveForm = false;
    this.alertShow = true;
    this.alertType = "error";
    this.alertMessage = this.utilService.alertErrorMessage(error);
  }

  lockEntity(id: number) {
    return this.apiService.lockData("unit", id);
  }

  unlockEntity() {
    this.apiService.unlockData("unit", this.entity.id).subscribe();
  }

  ngOnDestroy() {
    if (this.mode === "edit") {
      this.unlockEntity();
    }
  }
}
